export default __webpack_public_path__ + "static/media/qr.307b2d0f.jpg";